export default "__VITE_ASSET__03f4f928__"